import { Box } from "@chakra-ui/react";
import dynamic from "next/dynamic";
import Head from "next/head";

import ValuationContext from "@/context/valuationContext";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const Valuacion = dynamic(() => import("@/sections/valuacion/Valuacion"));

const LayoutValuacion = () => {
    return (
        <>
            <Head>
                <title> Valuación | Grupo Guía </title>
            </Head>
            <Header />

            <Box pt={20} mt={16} pb={20}>
                <ValuationContext>
                    <Valuacion />
                </ValuationContext>
            </Box>

            <Footer esGuiaRent={false} />
        </>
    );
};

export default LayoutValuacion;
